import axios from 'axios';
import qs from 'qs';
import router from '../router';
import Vue from "vue";

// let baseURL = 'https://gw.dev.deepvision.link';
let baseURL = process.env.VUE_APP_HOST;
// 创建 axios 实例
let service = {}
/**
     * 全局配置文件
     */
service = axios.create({
  baseURL,
  timeout: 60 * 1000,
  headers: {
    // TODO 后端服务器采用的是该编码格式 后期统一转换成json格式
    'Content-Type': 'application/json'
    // "jzToken": userInfo ? userInfo.token : ''
  }
})

/**
     * 全局拦截请求
     *
     */
service.interceptors.request.use(function (config) {
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  config.headers.accessToken = userInfo.token || '';
  config.headers.clientPlatform = 3;
  config.headers.version = "v1.2.0";
  // 序列化请求参数
  // if (config.method === 'post' || config.method === 'get') config.data = qs.stringify(config.data)
  return config;
}, function (error) {
  console.error("error:", error); // for debug
  Promise.reject(error);
});

/**
     * 全局拦截响应
     */
service.interceptors.response.use(function (res) {
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  let errcode = res.data.code;
  if (errcode == '00000') { // 成功
    return res.data.data; // 传数据
  } else if (errcode == '20001' || errcode == '20002' || errcode == '20003') { // 未登录
    Vue.prototype.$Notice.warning({
      type: 'warning',
      title: res.data.desc
    });
    router.replace({ path: '/login' })
  } else {
    Vue.prototype.$Notice.warning({
      type: 'warning',
      title: res.data.desc
    });
  }
}, function (error) {
  Promise.reject(error);
});

let $httpblob = axios.create({
  baseURL,
  timeout: 180 * 1000,
  responseType: 'blob',
  headers: {
    'Content-Type': 'application/json'
  }
})
/**
     * 全局拦截请求
     *
     */
$httpblob.interceptors.request.use(function (config) {
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  config.headers.accessToken = userInfo.token || '';
  config.headers.clientPlatform = 3;
  config.headers.version = "v1.2.0";
  // 序列化请求参数
  // if (config.method === 'post' || config.method === 'get') config.data = qs.stringify(config.data)
  return config;
}, function (error) {
  console.error("error:", error); // for debug
  Promise.reject(error);
});
// 导出-二进制流
async function blobpost (url, param = {}, callback) {
  const res = await $httpblob.post(url, param)
  return res
}
Vue.prototype.$blobpost = blobpost;
Vue.prototype.$httpblob = $httpblob
window.$blobpost = blobpost

export default service;
